module.exports = __webpack_public_path__ + "img/SketchPng5c78db69bc2968cd4d1cb8fd6a7a703db19a08b2dc00af0abb11f9bc0d7b0040.c22fa8ad.png";